export enum RetailMatchTimeOption {
  TwentyNineteen,
  ThreeMonths,
  SixMonths,
  TwelveMonths,
}
